export enum AvatarType {
  FEMALE = 'female',
  MALE = 'male',
  NEUTRAL = 'neutral',
  ORGANIZATION = 'organization'
}
